export const orderStatusCategoryKeys = ['completed', 'received', 'cancelled'];

export const orderStatusIds = (statuses) => statuses.map((status) => status.value);

export function hasOrderStatusDraftChanges(statusSettings, statusDraft) {
    if (!statusSettings || !statusDraft) return false;

    return orderStatusCategoryKeys.some((key) => {
        const persisted = [...orderStatusIds(statusSettings[key])].sort();
        const drafted = [...orderStatusIds(statusDraft[key])].sort();
        return JSON.stringify(persisted) !== JSON.stringify(drafted);
    });
}
